// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class ByteValue implements flatbuffers.IUnpackableObject<ByteValueT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ByteValue {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsByteValue(bb: flatbuffers.ByteBuffer, obj?: ByteValue): ByteValue {
    return (obj || new ByteValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsByteValue(bb: flatbuffers.ByteBuffer, obj?: ByteValue): ByteValue {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ByteValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  value(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : 0;
  }

  static startByteValue(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addValue(builder: flatbuffers.Builder, value: number) {
    builder.addFieldInt8(0, value, 0);
  }

  static endByteValue(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createByteValue(builder: flatbuffers.Builder, value: number): flatbuffers.Offset {
    ByteValue.startByteValue(builder);
    ByteValue.addValue(builder, value);
    return ByteValue.endByteValue(builder);
  }

  unpack(): ByteValueT {
    return new ByteValueT(this.value());
  }

  unpackTo(_o: ByteValueT): void {
    _o.value = this.value();
  }

  unpackFields(...fields: string[]): ByteValueT {
    const t = new ByteValueT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("value")) {
      t.value = this.value();
    }
    return t;
  }
}

export class ByteValueT implements flatbuffers.IGeneratedObject {
  constructor(public value: number = 0) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return ByteValue.createByteValue(builder, this.value);
  }

  clone(): ByteValueT {
    const obj = new ByteValueT();
    obj.value = this.value;
    return obj;
  }

  equals(other: ByteValueT): boolean {
    if (this.value !== other.value) return false;
    return true;
  }
}

export function verifyByteValue(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
  } finally {
    verifier.popDepth();
  }
}
